export const fixationAllocations = (row) => {
  if (!row) return [];
  let allocations = row.ContainerAllocations;
  if (typeof allocations === "string") {
    try { allocations = JSON.parse(allocations); } catch { allocations = []; }
  }
  if (Array.isArray(allocations) && allocations.length) return allocations;
  return row.ShipmentID ? [{ ShipmentID: row.ShipmentID, ContainerNo: row.ContainerNo, Quantity: row.Quantity }] : [];
};

export const fixationMatchesContainer = (fixation, container) => fixationAllocations(fixation).some(allocation =>
  String(allocation.ShipmentID) === String(container.ShipmentID || container.ContainerID || "") ||
  (allocation.ContainerNo && allocation.ContainerNo === (container.ContainerNo || container.containerNo))
);
